import { createContext, useContext } from 'react';

export type ActiveItem = string | undefined;

export const ActiveItemContext = createContext<ActiveItem>(undefined);

export function useActiveItem(): ActiveItem {
  return useContext(ActiveItemContext);
}
